var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2083 4.375H7.79167C6.17292 4.375 4.875 5.6875 4.875 7.29167V27.7083C4.875 29.3125 6.17292 30.625 7.79167 30.625H28.2083C29.8125 30.625 31.125 29.3125 31.125 27.7083V7.29167C31.125 5.6875 29.8271 4.375 28.2083 4.375ZM28.2083 27.7083H7.79167V10.2083H28.2083V27.7083ZM18 15.3125C20.6833 15.3125 23.075 16.7125 24.3292 18.9583C23.075 21.2042 20.6833 22.6042 18 22.6042C15.3167 22.6042 12.925 21.2042 11.6708 18.9583C12.925 16.7125 15.3167 15.3125 18 15.3125ZM18 13.125C14.0188 13.125 10.6208 15.5458 9.25 18.9583C10.6208 22.3708 14.0188 24.7917 18 24.7917C21.9812 24.7917 25.3792 22.3708 26.75 18.9583C25.3792 15.5458 21.9812 13.125 18 13.125ZM18 21.1458C16.7896 21.1458 15.8125 20.1688 15.8125 18.9583C15.8125 17.7479 16.7896 16.7708 18 16.7708C19.2104 16.7708 20.1875 17.7479 20.1875 18.9583C20.1875 20.1688 19.2104 21.1458 18 21.1458Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.51f4f9983b2b4c877cba40912ece120a.svg";
export { ForwardRef as ReactComponent };